/**
 * Возвращает массив характеристик значения (value) которых
 * совпадает с filterValue.
 *
 * @param {Object[]} traits
 * @param {string} traits[].value
 * @param {String} filterValue
 */

export const getFilteredTraits = (traits = [], filterValue = '') =>
  traits.filter((trait) => {
    const value = trait.value.toLowerCase();
    return value.includes(filterValue.toLowerCase());
  });

/**
 * Создает url адрес на основании списка характеристик.
 *
 * @param {Object[]} traits
 * @param {Boolean} traits[].checked
 * @param {String} traits[].slug
 * @param {String} urlPattern
 * @param {String} urlReplace
 * @param {String} url
 */

export const getSummaryFilteredUrl = (
  traits = [],
  urlPattern,
  urlReplace,
  url
) => {
  const selectedTraits = traits
    .filter((trait) => trait.checked)
    .map((trait) => trait.slug)
    .join('|');

  return selectedTraits ? urlPattern.replace(urlReplace, selectedTraits) : url;
};

/**
 * Создает новый список характеристик на основе id
 * характеристики с которой взаимодействовал пользователь.
 *
 * @param {Object[]} traits
 * @param {Number} traits[].id
 * @param {Boolean} traits[].checked
 * @param {Number} id
 */

export const getProcessedTraitList = (traits = [], id) => {
  return traits.map((trait) => {
    const updatedTrait = {...trait, showTip: trait.id === id};

    if (trait.id === id) {
      updatedTrait.checked = !updatedTrait.checked;
    }

    return updatedTrait;
  });
};

/**
 * Создает css строку для позиционирования всплывающей подсказки
 *
 * @param {Object} refs
 * @param {Object[]} traits
 * @param {Boolean} traits[].showTip
 */

export const getTipPositionStyle = (refs, traits) => {
  const containerEl = refs.container;
  const item = traits.filter((trait) => trait.showTip)[0];
  const anchorEl = item && refs[item.id][0];

  if (!anchorEl) {
    return;
  }

  const itemTop = anchorEl.getBoundingClientRect().top;
  const itemLeft =
    anchorEl.getBoundingClientRect().left +
    anchorEl.getBoundingClientRect().width;

  const containerTop = containerEl.getBoundingClientRect().top;
  const containerLeft = containerEl.getBoundingClientRect().left;

  return `top: ${itemTop - containerTop}px; left: ${
    itemLeft - containerLeft
  }px;`;
};
